import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import ColorScale from '_class/ColorScale';
import { FlexibleTextArea } from 'UI/Inputs';
import { Checkbox, Flex, Icon } from '@haldor/ui';
import { useTranslate } from 'lib/translate';
import sniffer from 'sniffer';

var GoalMatrixRowForm = function GoalMatrixRowForm(props) {
  var _props$row, _props$row$descriptio, _props$row2;

  var rebuildIndexes = function rebuildIndexes(cell, index) {
    return _objectSpread(_objectSpread({}, cell), {}, {
      index: index
    });
  };

  var initialCells = [];

  if (((_props$row = props.row) === null || _props$row === void 0 ? void 0 : _props$row.cells) != null) {
    initialCells = props.row.cells.sort(function (a, b) {
      return a.index - b.index;
    }).map(rebuildIndexes);
  }

  var translate = useTranslate();

  var _useState = useState(initialCells),
      _useState2 = _slicedToArray(_useState, 2),
      cells = _useState2[0],
      setCells = _useState2[1];

  var _useState3 = useState((_props$row$descriptio = (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.description) !== null && _props$row$descriptio !== void 0 ? _props$row$descriptio : ''),
      _useState4 = _slicedToArray(_useState3, 2),
      description = _useState4[0],
      setDescription = _useState4[1];

  var onChange = function onChange(parentCells) {
    var cellValues = cells;

    if (parentCells != null) {
      cellValues = parentCells;
    }

    if (props.onChange != null) {
      if (props.row != null) {
        props.onChange(_objectSpread(_objectSpread({}, props.row), {}, {
          description: description,
          cells: cellValues
        }));
      } else {
        props.onChange({
          description: description,
          cells: cellValues
        });
      }
    }
  };

  var onDescriptionChange = function onDescriptionChange(event) {
    setDescription(event.target.value);
  };

  var onCellChange = function onCellChange(cell, event) {
    if (cell == null) {
      return false;
    }

    var newCells = _toConsumableArray(cells);

    newCells.splice(cell.index, 1, _objectSpread(_objectSpread({}, cell), {}, {
      value: event.target.value
    }));
    setCells(newCells);
  };

  var onCellCopy = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cell, event) {
      var newCells;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();

              if (!(cell == null)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", false);

            case 3:
              newCells = _toConsumableArray(cells);
              newCells.splice(cell.index, 0, {
                index: 0,
                value: cell.value,
                type: 'TextField',
                id: 0
              }); // Rebuild indexes on cells

              newCells = newCells.map(rebuildIndexes);
              _context.next = 8;
              return setCells(newCells);

            case 8:
              onChange(newCells);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onCellCopy(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var onCellRemove = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cell, event) {
      var newCells;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.preventDefault();

              if (!(cell == null)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", false);

            case 3:
              newCells = _toConsumableArray(cells);
              newCells.splice(cell.index, 1); // Rebuild indexes on cells

              newCells = newCells.map(rebuildIndexes);
              setCells(newCells);
              onChange(newCells);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onCellRemove(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onAddCell = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
      var newCells;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              event.preventDefault();
              newCells = _toConsumableArray(cells);
              newCells.push({
                index: cells.length,
                type: 'TextField',
                value: '',
                id: 0
              });
              setCells(newCells);
              onChange(newCells);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function onAddCell(_x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  var toggleNotAchieved = function toggleNotAchieved(add) {
    var newCells = _toConsumableArray(cells);

    if (add) {
      newCells = [{
        index: 0,
        type: 'NotAchievedTextField',
        value: translate('Not achieved'),
        id: 0
      }].concat(_toConsumableArray(cells)).map(rebuildIndexes);
    } else {
      newCells = _toConsumableArray(cells).filter(function (cell) {
        return cell.type != 'NotAchievedTextField';
      }).map(rebuildIndexes);
    }

    setCells(newCells);
    onChange(newCells);
  };

  var hasAchieved = cells.find(function (cell) {
    return cell.type == 'NotAchievedTextField';
  }) != null;
  var colors = new ColorScale(cells.length).get(hasAchieved);
  return /*#__PURE__*/React.createElement("div", {
    className: "form form-component scrollable"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-row",
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    column: sniffer.isPhone,
    row: !sniffer.isPhone
  }, /*#__PURE__*/React.createElement("div", {
    className: "cell description"
  }, /*#__PURE__*/React.createElement(FlexibleTextArea, {
    onChange: onDescriptionChange,
    onBlur: function onBlur() {
      return onChange();
    },
    placeholder: translate('Goal description'),
    value: description,
    disabled: props.disabled
  })), cells.map(function (cell, index) {
    var color = colors[index];
    return /*#__PURE__*/React.createElement("div", {
      className: "cell has-color",
      key: index,
      style: {
        '--level-color': color
      }
    }, /*#__PURE__*/React.createElement(FlexibleTextArea, {
      onChange: function onChange(event) {
        return onCellChange(cell, event);
      },
      onBlur: function onBlur() {
        return onChange();
      },
      value: cell.value,
      disabled: props.disabled
    }), !props.disabled ? /*#__PURE__*/React.createElement("div", {
      className: "controls"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cell-buttons"
    }, cell.type != 'NotAchievedTextField' ? /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(event) {
        return onCellCopy(cell, event);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "Copy"
    })) : null, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(event) {
        return onCellRemove(cell, event);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "Bin"
    })))) : null);
  }), !props.disabled ? /*#__PURE__*/React.createElement("div", {
    className: "controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "add-cell-button",
    onClick: onAddCell
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Plus"
  }), " ", translate('Add step'))) : null), /*#__PURE__*/React.createElement("div", {
    className: "controls row-form-settings"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    value: hasAchieved,
    onChange: toggleNotAchieved,
    label: translate('Add step for not achieved'),
    disabled: props.disabled
  }))));
};

GoalMatrixRowForm.defaultProps = {
  disabled: false
};
export default GoalMatrixRowForm;